export default "__VITE_ASSET__C_evndQc__"